/* Memorial · prefiltro "¿A quién rinden homenaje?" (11-oct-2026)
   Reglas de color:
   - Él:   blancos, amarillos, celestes/azules y rojos.
   - Ella: blancos, rojos, rosados, lilas, fucsias, amarillo con rosado y rosado con lila.
   - Ver todos: todo el catálogo.
   Oculta los arreglos sin ningún color para esa persona y, si el arreglo tiene un color que sí corresponde,
   muestra esa foto. En la ficha de producto oculta los colores que no corresponden (con opción de verlos).
   La elección se recuerda en este navegador y no bloquea la página. */
(function () {
  'use strict';
  var CLAVE = 'mm_publico';
  // Misma regla que snippets/mm-colores.liquid y mm-publico-card.liquid
  function codigos(t) {
    t = ' ' + String(t || '').toLowerCase() + ' ';
    return {
      B: /blanc/.test(t), A: /amarill|girasol/.test(t), C: /celest|azul/.test(t), RJ: /roj|carmes/.test(t),
      R: /rosad| rosa |durazno/.test(t), L: /lila|morad|malva/.test(t), F: /fucs|fucci/.test(t)
    };
  }
  function sirve(texto, quien) {
    var c = codigos(texto);
    if (quien === 'el') return !(c.R || c.L || c.F);
    if (quien === 'ella') return !c.C && (!c.A || c.R);
    return true;
  }
  var NO_VA = { el: 'en tonos rosados y lilas', ella: 'solo en amarillos o celestes' };
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function leer() { try { return localStorage.getItem(CLAVE) || ''; } catch (e) { return ''; } }
  function guardar(v) { try { if (v) localStorage.setItem(CLAVE, v); else localStorage.removeItem(CLAVE); } catch (e) {} }
  function evento(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre }; for (var k in datos) o[k] = datos[k];
    window.dataLayer.push(o);
  }

  // requestAnimationFrame con respaldo: algunos navegadores lo pausan y dejarían elementos a medio animar
  function cuadro(fn) {
    var hecho = false;
    var f = function () { if (!hecho) { hecho = true; fn(); } };
    if (window.requestAnimationFrame) requestAnimationFrame(f);
    setTimeout(f, 50);
  }

  var estado = leer();
  document.documentElement.setAttribute('data-mm-publico', estado);

  /* ---------- datos de cada tarjeta ---------- */
  function datos(card) {
    if (card.__mmPub !== undefined) return card.__mmPub;
    var s = card.querySelector('script.mm-pub'), d = null;
    try { d = s ? JSON.parse(s.textContent) : null; } catch (e) { d = null; }
    card.__mmPub = d;
    return d;
  }
  // e = sirve para él, a = sirve para ella
  function clave(q) { return q === 'el' ? 'e' : q === 'ella' ? 'a' : null; }
  function primeroPara(d, q) {
    var k = clave(q);
    if (!d || !d.l || !k) return null;
    for (var i = 0; i < d.l.length; i++) if (d.l[i][k]) return d.l[i];
    return null;
  }

  /* API mínima para mm-hover-color.js */
  window.MMPublico = {
    estado: function () { return estado; },
    fotosHover: function (card) {
      var d = datos(card);
      var k = clave(estado);
      if (!d || !d.l || !k) return null;
      var actual = card.__mmFoto ? card.__mmFoto.v : null;
      return d.l.filter(function (x) { return x[k] && !x.b && x.v !== actual; });
    }
  };

  /* ---------- foto principal ---------- */
  function cambiarFoto(card, item) {
    var caja = card.querySelector('.m-product-card__main-image');
    var img = caja && caja.querySelector('img');
    if (!img) return;
    if (!card.__mmOrig) {
      card.__mmOrig = {
        src: img.getAttribute('src'), srcset: img.getAttribute('srcset'),
        links: Array.prototype.map.call(card.querySelectorAll('a[href*="/products/"]'), function (a) { return [a, a.getAttribute('href')]; })
      };
    }
    var dest = item ? { src: item.u, srcset: item.s } : { src: card.__mmOrig.src, srcset: card.__mmOrig.srcset };
    card.__mmFoto = item || null;
    card.__mmOrig.links.forEach(function (par) {
      var h = par[1];
      if (item && item.v) h = h.split('?')[0] + '?variant=' + item.v;
      par[0].setAttribute('href', h);
    });
    if (img.getAttribute('src') === dest.src) return;
    var poner = function () {
      img.removeAttribute('loading');
      if (dest.srcset) img.setAttribute('srcset', dest.srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', dest.src);
    };
    if (reducido) { poner(); return; }
    caja.classList.add('mm-pub-cambia');
    var pre = new Image();
    if (img.sizes) pre.sizes = img.sizes;
    if (dest.srcset) pre.srcset = dest.srcset;
    pre.src = dest.src;
    var listo = function () {
      setTimeout(function () { poner(); cuadro(function () { caja.classList.remove('mm-pub-cambia'); }); }, 160);
    };
    if (pre.decode) pre.decode().then(listo, listo); else pre.onload = pre.onerror = listo;
  }

  /* ---------- foto al pasar el cursor ---------- */
  function ajustarHover(card, d) {
    var hov = card.querySelector('.m-product-card__hover-image img');
    if (!hov) return;
    if (!card.__mmHov) card.__mmHov = { src: hov.getAttribute('src'), srcset: hov.getAttribute('srcset') };
    var k = clave(estado);
    var tieneOtros = k && d.l && d.l.some(function (x) { return !x[k]; });
    if (tieneOtros) {
      var opciones = window.MMPublico.fotosHover(card);
      if (opciones && opciones.length) {
        var f = opciones[0];
        hov.removeAttribute('loading');
        hov.setAttribute('srcset', f.s); hov.setAttribute('src', f.u);
        card.classList.remove('mm-pub-sin-hover');
      } else {
        card.classList.add('mm-pub-sin-hover');
      }
    } else {
      card.classList.remove('mm-pub-sin-hover');
      if (card.__mmHov.srcset) hov.setAttribute('srcset', card.__mmHov.srcset);
      hov.setAttribute('src', card.__mmHov.src);
    }
  }

  /* ---------- colección ---------- */
  var barra = null, estadoEl = null;

  function contenedor() { var g = document.getElementById('CollectionProductGrid'); return g ? g.querySelector('[data-product-container]') : null; }
  function visible(el) { return el.offsetParent !== null && getComputedStyle(el).display !== 'none'; }

  function aplicar(animar) {
    document.documentElement.setAttribute('data-mm-publico', estado);
    var cont = contenedor();
    if (!cont) return;
    var items = Array.prototype.slice.call(cont.children).filter(function (n) { return n.classList && n.classList.contains('m-product-item'); });
    var ocultar = [], mostrar = [], ocultos = 0;

    items.forEach(function (it) {
      var card = it.querySelector('.m-product-card');
      var d = card && datos(card);
      if (!d) return;
      var k = clave(estado);
      var esconder = !!k && !d[k];
      if (esconder) ocultos++;
      var yaOculto = it.classList.contains('mm-pub-oculto');
      if (esconder && !yaOculto) ocultar.push(it);
      if (!esconder && yaOculto) mostrar.push(it);
      if (!esconder) {
        if (k && !d['b' + k]) cambiarFoto(card, primeroPara(d, estado));
        else if (card.__mmOrig) cambiarFoto(card, null);
        ajustarHover(card, d);
      }
    });

    var terminar = function () { contar(cont, ocultos); };
    if (!animar || reducido || (!ocultar.length && !mostrar.length)) {
      ocultar.forEach(function (it) { it.classList.add('mm-pub-oculto'); });
      mostrar.forEach(function (it) { it.classList.remove('mm-pub-oculto'); });
      terminar();
      return;
    }
    // 1) se desvanecen las que salen  2) el resto se acomoda con suavidad (FLIP)  3) aparecen las que entran
    ocultar.forEach(function (it) { it.classList.add('mm-pub-sale'); });
    setTimeout(function () {
      var antes = new Map();
      items.forEach(function (it) { if (visible(it) && ocultar.indexOf(it) < 0) antes.set(it, it.getBoundingClientRect()); });
      ocultar.forEach(function (it) { it.classList.add('mm-pub-oculto'); it.classList.remove('mm-pub-sale'); });
      mostrar.forEach(function (it) { it.classList.add('mm-pub-entra'); it.classList.remove('mm-pub-oculto'); });
      antes.forEach(function (r, it) {
        var n = it.getBoundingClientRect();
        var dx = r.left - n.left, dy = r.top - n.top;
        if ((dx || dy) && it.animate && Math.abs(dy) < window.innerHeight * 1.5) {
          it.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
      });
      cuadro(function () {
        mostrar.forEach(function (it, i) {
          setTimeout(function () {
            it.classList.add('mm-pub-entra-fin'); it.classList.remove('mm-pub-entra');
            setTimeout(function () { it.classList.remove('mm-pub-entra-fin'); }, 320);
          }, Math.min(i, 8) * 30);
        });
      });
      terminar();
    }, 200);
  }

  function contar(cont, ocultos) {
    var vistos = 0;
    Array.prototype.forEach.call(cont.children, function (it) { if (it.classList && it.classList.contains('m-product-item') && visible(it)) vistos++; });
    var vacio = cont.parentNode.querySelector('.mm-pub-vacio');
    if (NO_VA[estado] && vistos === 0 && ocultos > 0) {
      if (!vacio) {
        vacio = document.createElement('div');
        vacio.className = 'mm-pub-vacio';
        vacio.innerHTML = '<p>En esta categoría no hay arreglos en estos colores.</p><button type="button">Ver todos los arreglos</button>';
        vacio.querySelector('button').addEventListener('click', function () { elegir('todos'); });
        cont.parentNode.insertBefore(vacio, cont.nextSibling);
      }
    } else if (vacio) { vacio.remove(); }

    if (!estadoEl) return;
    var arreglos = vistos === 1 ? '1 arreglo' : vistos + ' arreglos';
    if (NO_VA[estado]) estadoEl.textContent = ocultos > 0 ? arreglos + ' · ocultamos ' + ocultos + ' ' + NO_VA[estado] : arreglos;
    else if (estado) estadoEl.textContent = arreglos;
    else estadoEl.textContent = '';
  }

  // Cuántos arreglos de esta página verá cada uno (se muestra en las tarjetas del paso inicial)
  function contarOpciones() {
    var cont = contenedor();
    if (!cont || !barra) return;
    var n = { el: 0, ella: 0 };
    Array.prototype.forEach.call(cont.querySelectorAll('.m-product-card'), function (card) {
      var d = datos(card);
      if (!d) return;
      if (d.e) n.el++;
      if (d.a) n.ella++;
    });
    Array.prototype.forEach.call(barra.querySelectorAll('[data-mm-pub-n]'), function (el) {
      var q = el.getAttribute('data-mm-pub-n');
      el.textContent = n[q] ? n[q] + (n[q] === 1 ? ' arreglo' : ' arreglos') : '';
    });
  }

  function pintarBarra() {
    if (!barra) return;
    barra.setAttribute('data-estado', estado ? 'elegido' : 'pregunta');
    Array.prototype.forEach.call(barra.querySelectorAll('[data-mm-pub-op]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mm-pub-op') === estado ? 'true' : 'false');
    });
  }

  function esMovil() { return window.matchMedia && window.matchMedia('(max-width: 767px)').matches; }

  function irAProductos() {
    var g = contenedor() || document.getElementById('CollectionProductGrid');
    if (!g) return;
    var cab = document.querySelector('.m-header__sticky, .m-header, header');
    var alto = cab ? Math.min(cab.getBoundingClientRect().height, 120) : 0;
    var destino = function () { return Math.max(0, g.getBoundingClientRect().top + window.pageYOffset - alto - 12); };
    var raiz = document.documentElement, previo = raiz.style.scrollBehavior;
    raiz.style.scrollBehavior = 'auto'; // el tema usa scroll suave global; lo animamos nosotros para que no se corte
    var desde = window.pageYOffset, t0 = Date.now(), dur = reducido ? 0 : 520;
    var paso = function () {
      var p = dur ? Math.min(1, (Date.now() - t0) / dur) : 1;
      var e = 1 - Math.pow(1 - p, 3);
      window.scrollTo(0, desde + (destino() - desde) * e);
      if (p < 1) setTimeout(paso, 16); else raiz.style.scrollBehavior = previo;
    };
    paso();
  }

  function elegir(v, origen) {
    var antes = estado;
    estado = v;
    guardar(estado);
    pintarBarra();
    aplicar(true);
    if (antes !== estado) evento('mm_publico', { publico: estado, origen: origen || 'barra' });
    // Desde el paso inicial en celular: al elegir, la pregunta se recoge y bajamos a los arreglos
    if (origen === 'paso' && esMovil()) setTimeout(irAProductos, reducido ? 0 : 460);
  }

  function iniciarColeccion() {
    barra = document.querySelector('[data-mm-prefiltro]');
    if (!barra) return;
    estadoEl = barra.querySelector('[data-mm-pub-estado]');
    Array.prototype.forEach.call(barra.querySelectorAll('[data-mm-pub-op]'), function (b) {
      var enPaso = !!b.closest('[data-mm-pub-paso]');
      b.addEventListener('click', function () { elegir(b.getAttribute('data-mm-pub-op'), enPaso ? 'paso' : 'barra'); });
    });
    // Al cargar, el estado se pinta sin animación; las transiciones solo acompañan una elección
    barra.classList.add('mm-pub--sin-anim');
    pintarBarra();
    aplicar(false);
    contarOpciones();
    setTimeout(function () { barra.classList.remove('mm-pub--sin-anim'); }, 60);
    if (!estado && esMovil()) evento('mm_publico_paso_visto', {});
    var g = document.getElementById('CollectionProductGrid');
    if (g && window.MutationObserver) {
      var t = null;
      new MutationObserver(function (muts) {
        var nuevos = muts.some(function (m) { return m.addedNodes && m.addedNodes.length; });
        if (!nuevos) return;
        clearTimeout(t); t = setTimeout(function () { aplicar(false); }, 60);
      }).observe(g, { childList: true, subtree: true });
    }
  }

  /* ---------- ficha de producto ---------- */
  function iniciarProducto() {
    if (!NO_VA[estado]) return;
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var nodos = Array.prototype.slice.call(picker.querySelectorAll('.m-product-option--node[data-value]'));
    if (nodos.length < 2) return;
    var mujer = nodos.filter(function (n) { return !sirve(n.getAttribute('data-value'), estado); });
    var otros = nodos.filter(function (n) { return sirve(n.getAttribute('data-value'), estado); });
    if (!mujer.length || !otros.length) return;
    mujer.forEach(function (n) { n.hidden = true; n.style.display = 'none'; });
    var marcado = picker.querySelector('.m-product-option--node input:checked');
    var vieneDeEnlace = /[?&]variant=/.test(window.location.search);
    if (marcado && !sirve(marcado.value, estado) && !vieneDeEnlace) {
      var lbl = otros[0].querySelector('label');
      if (lbl) lbl.click();
    }
    var caja = mujer[0].parentNode;
    if (caja && !caja.parentNode.querySelector('.mm-pub-todos')) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mm-pub-todos';
      b.textContent = 'Ver todos los colores';
      b.style.cssText = 'margin:6px 0 0;padding:0;border:0;background:none;color:#172B21;font:inherit;font-size:13px;text-decoration:underline;cursor:pointer';
      b.addEventListener('click', function () { mujer.forEach(function (n) { n.hidden = false; n.style.display = ''; }); b.remove(); });
      caja.parentNode.insertBefore(b, caja.nextSibling);
    }
  }

  function todo() { iniciarColeccion(); iniciarProducto(); }
  if (document.readyState !== 'loading') todo(); else document.addEventListener('DOMContentLoaded', todo);
})();
